"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType[EventType["DotnetAcquisitionStart"] = 0] = "DotnetAcquisitionStart";
    EventType[EventType["DotnetSDKAcquisitionStart"] = 1] = "DotnetSDKAcquisitionStart";
    EventType[EventType["DotnetRuntimeAcquisitionStart"] = 2] = "DotnetRuntimeAcquisitionStart";
    EventType[EventType["DotnetASPNetRuntimeAcquisitionStarted"] = 3] = "DotnetASPNetRuntimeAcquisitionStarted";
    EventType[EventType["DotnetAcquisitionCompleted"] = 4] = "DotnetAcquisitionCompleted";
    EventType[EventType["DotnetAcquisitionError"] = 5] = "DotnetAcquisitionError";
    EventType[EventType["DotnetAcquisitionFinalError"] = 6] = "DotnetAcquisitionFinalError";
    EventType[EventType["DotnetAcquisitionSuccessEvent"] = 7] = "DotnetAcquisitionSuccessEvent";
    EventType[EventType["DotnetAcquisitionMessage"] = 8] = "DotnetAcquisitionMessage";
    EventType[EventType["DotnetAcquisitionTest"] = 9] = "DotnetAcquisitionTest";
    EventType[EventType["DotnetAcquisitionAlreadyInstalled"] = 10] = "DotnetAcquisitionAlreadyInstalled";
    EventType[EventType["DotnetAcquisitionInProgress"] = 11] = "DotnetAcquisitionInProgress";
    EventType[EventType["DotnetUninstallMessage"] = 12] = "DotnetUninstallMessage";
    EventType[EventType["DotnetTotalSuccessEvent"] = 13] = "DotnetTotalSuccessEvent";
    EventType[EventType["OfflineInstallUsed"] = 14] = "OfflineInstallUsed";
    EventType[EventType["OfflineWarning"] = 15] = "OfflineWarning";
    EventType[EventType["DotnetUpgradedEvent"] = 16] = "DotnetUpgradedEvent";
    EventType[EventType["SuppressedAcquisitionError"] = 17] = "SuppressedAcquisitionError";
    EventType[EventType["DotnetVisibleWarning"] = 18] = "DotnetVisibleWarning";
    EventType[EventType["DotnetInstallExpectedAbort"] = 19] = "DotnetInstallExpectedAbort";
    EventType[EventType["DotnetModalChildEvent"] = 20] = "DotnetModalChildEvent";
    // Example: DotnetAcquisitionStarted -> Children events are RuntimeStarted, SDKStarted, etc.
    EventType[EventType["FeedInjectionMessage"] = 21] = "FeedInjectionMessage";
})(EventType || (exports.EventType = EventType = {}));
//# sourceMappingURL=EventType.js.map